module.exports = __webpack_public_path__ + "img/UTESCA-2.b5bbcba0.jpg";